var p = Object.defineProperty, x = Object.defineProperties;
var R = Object.getOwnPropertyDescriptors;
var d = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, v = Object.prototype.propertyIsEnumerable;
var m = (i, r, n) => r in i ? p(i, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : i[r] = n, e = (i, r) => {
  for (var n in r || (r = {}))
    s.call(r, n) && m(i, n, r[n]);
  if (d)
    for (var n of d(r))
      v.call(r, n) && m(i, n, r[n]);
  return i;
}, f = (i, r) => x(i, R(r));
var g = (i, r) => {
  var n = {};
  for (var o in i)
    s.call(i, o) && r.indexOf(o) < 0 && (n[o] = i[o]);
  if (i != null && d)
    for (var o of d(i))
      r.indexOf(o) < 0 && v.call(i, o) && (n[o] = i[o]);
  return n;
};
import { jsxs as c, jsx as t } from "react/jsx-runtime";
import { Ring as j } from "./style.es.js";
function l(r) {
  var i = g(r, []);
  return /* @__PURE__ */ c(j, f(e({}, i), { children: [
    /* @__PURE__ */ t("div", {}),
    /* @__PURE__ */ t("div", {}),
    /* @__PURE__ */ t("div", {}),
    /* @__PURE__ */ t("div", {})
  ] }));
}
export {
  l as Ring
};
//# sourceMappingURL=Ring.es.js.map
